<template>
  <div class="headerWarp">
    <div class="headerTime">
      <!-- <a-button @click="goHomeHandle"></a-button> -->
      <img @click="goHomeHandle" src="~@/assets/bigusers/largeScreen/homePage.png" />
      <span>{{ date | formatDate }}</span>
    </div>
    <div class="headerTitle">
      <img src="~@/assets/myImg/title-01.png" />
      <span class="DataTitle">{{ name }}智慧水务平台</span>
    </div>
    <div class="right-content">
      <div class="weatherWarp">
        <span>{{ alarme.text }} {{ alarme.temp }}°C 风向：{{ alarme.windDir }}</span>
        <img class="fullImg" @click="quanping" :src="'/iconImg/' + (a % 2 == 1 ? 'h_h_min' : 'h_h_max') + '.png'" />
      </div>
      <div class="versionWarp" v-if="currentVersion">
        <span class="version-text">版本号: {{ currentVersion }}</span>
      </div>
    </div>
  </div>
</template>
<script>
var padDate = function (value) {
  return value < 10 ? '0' + value : value
}
export default {
  name: 'HeaderVisualization',
  data () {
    return {
      a: 0,
      date: new Date(),
      name: '',
      alarme: {
        temp: '',
        text: '',
        windDir: ''
      },
      systemList: [], // 系统列表
      currentVersion: '' // 当前系统版本号
    }
  },
  filters: {
    formatDate: function (value) {
      var date = new Date(value)
      var year = date.getFullYear()
      var month = padDate(date.getMonth() + 1)
      var day = padDate(date.getDate())
      var hours = padDate(date.getHours())
      var minutes = padDate(date.getMinutes())
      var seconds = padDate(date.getSeconds())
      // 整理并返回
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
    }
  },
  mounted: function () {
    var _this = this // 指向this 变量作用域一致;
    this.timer = setInterval(function () {
      _this.date = new Date() // 修改date
    }, 1000)
  },
  created () {
    this.name = this.$store.state.user.info.nickName
    this.getOnlineAlarme()
    this.getSystemList()
  },
  methods: {
    quanping () {
      this.a++
      this.a % 2 == 1 ? this.enterfullscreen() : this.exitfullscreen()
      console.log(this.a)
    },
    getOnlineAlarme () {
      this.$http.get('/pipe-network/report/chart/get-weather').then(res => {
        this.alarme = res.data.now
      })
    },
    enterfullscreen () {
      // 进入全屏
      var docElm = document.documentElement
      // W3C
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen()
      }
      // FireFox
      else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen()
      }
      // Chrome等
      else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen()
      }
      // IE11
      else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen()
      }
    },
    // 退出全屏
    exitfullscreen () {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      }
    },
    goHomeHandle () {
      this.$router.push('/')
    },
    // 获取系统列表
    getSystemList () {
      this.$http
        .get('/manager/users/app')
        .then((res) => {
          if (res.code === 0 || res.code === 200) {
            this.systemList = res.data || []
            // 获取系统列表后查询版本号
            this.querySystemVersion()
          }
        })
        .catch(() => {})
    },
    // 查询系统版本号
    querySystemVersion () {
      // 查找 appCode 为 "DataVisualization" 的系统
      const system = this.systemList.find(item => item.appCode === 'DataVisualization')
      if (!system || !system.id) {
        this.currentVersion = ''
        return
      }
      
      // 调用接口查询版本号
      this.$http
        .get('/manager/sys_update_log/selectSysVersionNum', {
          params: {
            id: system.id
          }
        })
        .then((res) => {
          if (res.code === 0 || res.code === 200) {
            this.currentVersion = res.msg ||  ''
          } else {
            this.currentVersion = ''
          }
        })
        .catch(() => {
          this.currentVersion = ''
        })
    }
  }
}
</script>

<style lang="less" scoped>
.headerWarp {
  max-width: 100%;
  width: 100vw;
  height: 58px;
  opacity: 0.95;
  background: rgba(6, 13, 42, 0.75);
  border-bottom: 2px solid rgba(16, 192, 255, 0.25);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 0 20px;
  line-height: 58px;
  
  .headerTime {
    flex: 0 0 auto;
  }
  
  .headerTitle {
    flex: 1;
  }
  
  .right-content {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    gap: 12px;
  }

  .headerTime {
    font-family: MicrosoftYaHeiSemibold;
    font-size: 20px;
    color: #ffffff;
    font-weight: 600;
    display: flex;
    align-items: center;

    img {
      height: 32px;
      width: 32px;
      cursor: pointer;
    }

    span {
      margin-left: 12px;
    }
  }

  .headerTitle {
    // z-index: 1000;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    font-family: MicrosoftYaHeiSemibold;
    font-size: 36px;
    color: #10c0ff;
    text-align: center;
    font-weight: 600;

    .DataTitle {
      letter-spacing: 8px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
      display: block;
    }

    img {
      position: relative;
      z-index: 1000;
      width: 870px;
      height: 80px;
    }
  }

  .weatherWarp {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    margin-right: 0;

    span {
      font-family: MicrosoftYaHeiSemibold;
      font-size: 20px;
      color: #ffffff;
      display: inline-block;
      font-weight: 600;
    }

    .imgWeather {
      width: 18px;
      height: 18px;
      margin-right: 12px;
      // color: red;
      background-color: white;
    }

    .fullImg {
      width: 26px;
      height: 26px;
      margin-left: 12px;
      cursor: pointer;
    }
  }

  .versionWarp {
    display: flex;
    align-items: center;
    flex: 0 0 auto;

    .version-text {
      font-family: MicrosoftYaHeiSemibold;
      font-size: 18px;
      color: #ffffff;
      font-weight: 600;
      white-space: nowrap;
    }
  }
}
</style>
